export default __webpack_public_path__ + "static/media/link-broken_red.0d93bb07.svg";